export default function GalleryItem({ item, index }) {
  return (
    <article className={`gallery-item gallery-item-${index % 4}`}>
      <img src={item.image} alt={item.title} />
      <div className="gallery-caption">
        <h3>{item.title}</h3>
        <p>{item.description}</p>
      </div>
    </article>
  );
}